export class NotificationType {
  id: number;
  name: string;
  code: string;
}
